import { APIClient } from "./api_helper";
import {
  CHANGE_STATUS_ROLE,
  CHANGE_STATUS_USER,
  CREATE_ROLES_ENTITY,
  GET_ACTIVE_ROLES,
  GET_COUNTRIES,
  GET_CURRENCY_TYPE,
  GET_ENTITY_TYPE,
  GET_GENDER,
  GET_INFO_ENTITY_LEGALUSER,
  GET_LANGUAGES,
  GET_PERMISSIONS,
  GET_ROLES_SYSTEM,
  GET_STATE_COUNTRIES_TYPE,
  GET_USER_BY_ID,
  GET_USERS_ENTITY,
  POST_CREATE_USER,
  PUBLIC_GET_COUNTRIES,
  PUBLIC_GET_GENDERS,
  PUBLIC_TOKEN_GENERATE,
  UPDATE_INFO_USER_PROFILE,
  UPDATE_ROLES,
  PUBLIC_LOGOUT,
  UPDATE_USER_ROLES,
  POST_DOCUMENTS_ENTITY,
  GET_WALLETS_ENTITY,
  CREATE_WALLET,
  UPDATE_WALLET_INFO,
  GET_FIAT_CURRENCIES,
  GET_CRYPTO_CURRENCIES,
  GET_NETWORKS_WALLETS,
  UPDATE_STATUS_WALLET,
  GET_DOCUMENTS_ENTITY,
  GET_ECONOMIC_ACTIVITIES,
  GET_DOCUMENTS_TYPES,
  GET_COMPANTY_TYPE,
  CREATE_CUSTOMER_BRIDGE,
  GET_ENTITY_TYPE_LOG,
  CREATE_BUSINESS_BRIDGE,
} from "./url_helper";

const api = new APIClient();

// GENERALES
export const createPublicToken = async () =>
  api.post(PUBLIC_TOKEN_GENERATE, {});

export const getCountries = async () => api.get(GET_COUNTRIES, null);

export const getCurrencyType = async (countryAcronym: string) =>
  api.get(GET_CURRENCY_TYPE, { countryAcronym });

export const getStatesByCountry = async (countryAcronym: string) =>
  api.get(GET_STATE_COUNTRIES_TYPE, { countryAcronym });

export const getLanguages = async () => api.get(GET_LANGUAGES, null);

export const getGenders = async () => api.get(GET_GENDER, null);

export const getEconomicActivities = async (countryAcronym: string) =>
  api.get(GET_ECONOMIC_ACTIVITIES, { countryAcronym });

export const getPublicGenders = async () => api.get(PUBLIC_GET_GENDERS, {});

export const getPublicCountries = async () => api.get(PUBLIC_GET_COUNTRIES, {});

export const logOutUser = async () => api.post(PUBLIC_LOGOUT, {});

// NUEVOS ----------------

export const getDocumentsType = async () => api.get(GET_DOCUMENTS_TYPES, null);

export const getCompanyType = async () => api.get(GET_COMPANTY_TYPE, null);

// -----------------------------------------------
// ENTIDADES
export const getEntityType = async () => api.get(GET_ENTITY_TYPE, null);

export const getDocumentsEntity = async () =>
  api.get(GET_DOCUMENTS_ENTITY, null);

// USERS

export const addNewUserApi = (user: any) => api.create(POST_CREATE_USER, user);

export const getUsersByEntity = () => api.get(GET_USERS_ENTITY, {});

export const updateUserInfoProfile = (user: any) =>
  api.patch(UPDATE_INFO_USER_PROFILE, user);

export const getPermissions = () => api.get(GET_PERMISSIONS, {});

export const getUserById = (user_id: number) =>
  api.get(GET_USER_BY_ID, {
    user_id: user_id,
  });

export const changeUserStatus = (id: any) =>
  api.patch(`${CHANGE_STATUS_USER}${id}`, {});

export const updateUserRoleApi = (id: any, user: any) =>
  api.patch(`${UPDATE_USER_ROLES}${id}`, user);

//ROLES
export const getRolesByEntity = () => api.get(GET_ROLES_SYSTEM, {});

export const updateRoles = (id: any, user: any) =>
  api.patch(`${UPDATE_ROLES}${id}`, user);

export const createRoles = (roles: any) =>
  api.create(CREATE_ROLES_ENTITY, roles);

export const changeRoleStatus = (id: any) =>
  api.patch(`${CHANGE_STATUS_ROLE}${id}`, {});

export const getActiveRoles = () => api.get(GET_ACTIVE_ROLES, {});

export const getInfoEntityLegalUser = () =>
  api.get(GET_INFO_ENTITY_LEGALUSER, {});

export const postDocumentsByEntity = (data: any) =>
  api.post(POST_DOCUMENTS_ENTITY, data);

//WALLETS
export const getWalletsEntity = () => api.get(GET_WALLETS_ENTITY, {});

export const createWalletByEntity = (data: any) =>
  api.post(CREATE_WALLET, data);

export const updateWalletInfo = (id: any, data: any) =>
  api.put(`${UPDATE_WALLET_INFO}${id}`, data);

export const getFiatCurrencies = () => api.get(GET_FIAT_CURRENCIES, {});

export const getCryptoCurrencies = () => api.get(GET_CRYPTO_CURRENCIES, {});

export const getNetworkWallet = () => api.get(GET_NETWORKS_WALLETS, {});

export const deleteVirtualWallet = (id: any, data: any) =>
  api.put(`${UPDATE_STATUS_WALLET}${id}`, data);

//BRIDGE
export const getEntityTypeLog = (id: any) =>
  api.get(`${GET_ENTITY_TYPE_LOG}${id}`, {});

export const createCustomerIndividual = (data: any) =>
  api.post(CREATE_CUSTOMER_BRIDGE, data);

export const createBusinessBridge = (data: any) =>
  api.post(CREATE_BUSINESS_BRIDGE, data);
